const animation = `
    <span class="ajax-loader__animation" aria-hidden="true">
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
        <span class="ajax-loader__item"></span>
    </span>
`;

const icon = (src) => `
    <span class="ajax-loader__icon">
        <img src="${src}" alt="" aria-hidden="true" />
    </span>
`;

const template = ({ aria, ariaLive, className, customIcon, light, size, srText }) => {
    const rootAttrs = [
        aria && 'aria-atomic="true"',
        aria && ariaLive && `aria-live="${ariaLive}"`
    ].filter(attr => attr).join(' ');

    const mods = [
        light && '-light',
        size && `-${size}`
    ].filter(mod => mod).join(' ');

    const visual = customIcon ? icon(customIcon) : animation;

    return `
        <span class="ajax-loader ${className}" ${rootAttrs}>
            <span class="ajax-loader__main ${mods}" data-region="loader">
                <span class="sr-only">${srText}</span>

                ${visual}
            </span>
        </span>
    `;
};

export default template;
